import {IRouteStore} from '../../router/routing.infra';
import {getRootStore} from '../../app.bootstrap';
import {ILocalizationService} from '../../services/LocalizationService';
import {ITsEnvironmentDetect} from '@techsee/techsee-common/lib/helpers/ts-environment-detect';

export interface IConnectivityStandaloneStore extends IRouteStore {
    environmentService: ITsEnvironmentDetect;
    localizationService: ILocalizationService;
    dispose(): void;
}

export class ConnectivityStandaloneStore implements IConnectivityStandaloneStore {
    public environmentService: ITsEnvironmentDetect;
    public localizationService: ILocalizationService;

    constructor() {
        const rootStore = getRootStore();
        this.environmentService = rootStore.environmentService;
        this.localizationService = rootStore.localizationService;
    }

    dispose(): void {}
}
